import { baseApi, ENDPOINTS } from '@/shared/api';

import type {
    AccountLimitsResponse,
    MigrateRequest,
    MigrateResponse,
    MigrationStatusResponse,
    SelectAccountRequest,
    SelectAccountResponse,
} from '../model/types/plan-migration';

const planMigrationApi = baseApi
    .enhanceEndpoints({
        addTagTypes: ['AccountLimits'],
    })
    .injectEndpoints({
        endpoints: (build) => ({
            getMigrationStatus: build.query<MigrationStatusResponse, void>({
                query: () => ({
                    url: ENDPOINTS.subscription.migrationStatus,
                    method: 'GET',
                }),
            }),
            migrate: build.mutation<MigrateResponse, MigrateRequest>({
                query: (body) => ({
                    url: ENDPOINTS.subscription.migrate,
                    method: 'POST',
                    body,
                }),
            }),
            getAccountLimits: build.query<AccountLimitsResponse, void>({
                query: () => ({
                    url: ENDPOINTS.subscription.accountLimits,
                    method: 'GET',
                }),
                providesTags: ['AccountLimits'],
            }),
            selectAccount: build.mutation<
                SelectAccountResponse,
                SelectAccountRequest
            >({
                query: (body) => ({
                    url: ENDPOINTS.subscription.selectAccount,
                    method: 'POST',
                    body,
                }),
                invalidatesTags: ['AccountLimits'],
            }),
        }),
    });

export const {
    useLazyGetMigrationStatusQuery,
    useMigrateMutation,
    useGetAccountLimitsQuery,
    useSelectAccountMutation,
} = planMigrationApi;
